import ResponseStatusMapper from './ReponseStatusMapper';
import FindUnhandledData from './FindUnhandledData';

class PaymentMethodMappedParams {
  acctid: string;
  accttype: string;
  amount: string;
  authdate: string;
  authrespcode: string;
  capturedate: string;
  custom_attributes: string;
  expiry: string;
  fees: any;
  last4: string;
  lastfour: string;
  merchid: string;
  orderid: string;
  profileid: string;
  reqamount: string;
  respcode: string;
  respstat: string;
  resptext: string;
  retref: string;
  setlstat: string;
  settledate: string;
  unhandled_params: any;

  constructor(data: any) {
    const handledKeys = [
      'savedPaymentMethodId',
      'acctType',
      'authAmount',
      'authDate',
      'authResponseCode',
      'requestDate',
      'customAttributes',
      'cardExpiry',
      'fees',
      'lastFour',
      'merchid',
      'orderid',
      'payorId',
      'transactionAmount',
      'responseCode',
      'legacyResponseCode',
      'responseStatus',
      'transactionAmount',
      'retRef',
      'responseMessage',
      'settlementDate'
    ];

    this.acctid = data.savedPaymentMethodId;
    this.accttype = data.acctType;
    this.amount = data.authAmount;
    this.authdate = data.authDate;
    this.authrespcode = data.authResponseCode;
    this.capturedate = data.requestDate;
    this.custom_attributes = data.customAttributes;
    this.expiry = data.cardExpiry;
    this.fees = data.fees || [];
    this.last4 = data.lastFour;
    this.lastfour = data.lastFour;
    this.merchid = data.merchid;
    this.orderid = data.orderid;
    this.profileid = data.payorId;
    this.reqamount = data.transactionAmount;
    this.respcode = data.responseCode;
    this.respstat = data.legacyResponseCode || ResponseStatusMapper(data.responseStatus);
    this.resptext = data.transactionAmount;
    this.retref = data.retRef;
    this.setlstat = data.responseMessage;
    this.settledate = data.settlementDate;
    this.unhandled_params = FindUnhandledData(data, handledKeys);
  }
}

export default PaymentMethodMappedParams;
